module.exports = __webpack_public_path__ + "static/media/14.19f92ff9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/14.jpg
// module id = 175
// module chunks = 0